import React, { useEffect } from 'react'
import {
  IconButton,
  Text,
  VStack,
  useClipboard
} from '@chakra-ui/react'
import { BsCheckAll } from 'react-icons/bs'
import { MdOutlineContentCopy } from 'react-icons/md'
const Result = ({id, score, resultText}) => {
  useEffect(() => {
    setResultShareable(`The Daily Trivia Party for ${id} \n\n ${resultText.join('')} \n\n Have a go - http://dtparty.netlify.com/`)
  }, [id,resultText]);
  const [resultShareable, setResultShareable] = React.useState('')
  const { hasCopied, onCopy } = useClipboard(resultShareable)
  return (
    <VStack>
      <Text>You scored {score}/5 </Text>
      <Text> {resultText.join('')}  <IconButton onClick={onCopy} fontSize={'xl'} isRound variant={'ghost'} aria-label='Copy' icon={hasCopied ?<BsCheckAll/> :<MdOutlineContentCopy/>}></IconButton></Text>
    </VStack>
    )
}

export default Result